export enum TypesOfCookies {
  NECESSARY = 'NECESSARY',
  UNNECESSARY = 'UNNECESSARY',
}
